import { Component, OnInit } from '@angular/core';
import { SetorCliente } from '../../comum/modelos/setor-cliente';
import { Paginacao } from '../../comum/modelos/paginacao';
import { SetorService } from '../../setor/setor.service';
import { ProcessoService } from '../../processo/processo.service';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { Router } from '@angular/router';
import { ProcessoTabsetComponent } from '../../processo/processo-tabset/processo-tabset.component';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
    selector: 'app-listar-setores-cliente-processo',
    templateUrl: './listar-setores-cliente-processo.component.html',
    styleUrls: ['./listar-setores-cliente-processo.component.css']
})
export class ListarSetoresClienteProcessoComponent implements OnInit {

    filtroPesquisaNomeSetor: string;
    setoresCliente: SetorCliente[];
    setoresClienteSelecionados: SetorCliente[];
    paginacao: Paginacao;
    evento: Evento;
    selecionados: boolean;
    habilitarSelecaoProcessos: boolean;
    public loading = false;
    public statusCode: number;

    constructor(private _setorService: SetorService,
        private _comumService: ComumService,
        private _processoService: ProcessoService,
        private router: Router,
        private _processoTabsetComponent: ProcessoTabsetComponent,
        private _cookieService: CookieService,
        private _authService: AuthService) {
        this.paginacao = new Paginacao();
        this.setoresCliente = new Array<SetorCliente>();
        this.setoresClienteSelecionados = new Array<SetorCliente>();
        this.evento = this._comumService.evento;

        if (this.evento !== undefined) {
            setTimeout(() => {
                this._comumService.cleanEvent();
            }, 2000);
        }

    }

    ngOnInit() {
        this.paginacao.itens = 5;
        this.paginacao.page = 1;
        this.loading = true;

        const self = this;

        self._setorService.obterSetoresClienteHttp(parseInt(this._cookieService.get('idCliente')))
            .subscribe(setoresCliente => {
                self.setoresCliente = setoresCliente;
                self.loading = false;
            });
    }

    pesquisarPorFiltro(filtro: any): void {
        this.filtroPesquisaNomeSetor = filtro.value;
    }

    selecionar(setorCliente: SetorCliente): void {
        setorCliente.selecionado = !setorCliente.selecionado;
        if (setorCliente.selecionado) {
            this.setoresClienteSelecionados.push(setorCliente);
        } else {
            const index = this.setoresClienteSelecionados.indexOf(setorCliente);
            this.setoresClienteSelecionados.splice(index, 1);
        }

        if (this.setoresClienteSelecionados.length > 0) {
            this.habilitarSelecaoProcessos = true;
        } else {
            this.habilitarSelecaoProcessos = false;
        }
        setorCliente.alterado = true;
    }

    selecionarTodos(): void {
        this.selecionados = !this.selecionados;
        if (!this.selecionados) {
            this.habilitarSelecaoProcessos = false;
            this.setoresClienteSelecionados = new Array<SetorCliente>();
        } else {
            this.habilitarSelecaoProcessos = true;
        }
        this.setoresCliente.forEach(setorCliente => {
            if (this.selecionados) {
                this.setoresClienteSelecionados.push(setorCliente);
            }
            setorCliente.selecionado = this.selecionados;
            setorCliente.alterado = true;
        });
    }

    receberProcessosSetor(processosSetor: ProcessoSetor[]) {
        this.loading = true;
        const processosSetorInsert = new Array<ProcessoSetor>();
        const processosSetorDelete = new Array<ProcessoSetor>();
        processosSetor.forEach(processoSetor => {
            if (!processoSetor.selecionado && processoSetor.idProcessoSetor !== undefined && processoSetor.alterado) {
                processosSetorDelete.push(processoSetor);
            } else if (processoSetor.selecionado && processoSetor.idProcessoSetor === undefined
                && processoSetor.alterado) {
                processosSetorInsert.push(processoSetor);
            }
        });
        if (processosSetorDelete.length > 0) {
            this._processoService.removerProcessosSetorHttp(processosSetorDelete)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    this.router.navigate(['listar-processos']);
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
        if (processosSetorInsert.length > 0) {
            this._processoService.cadastrarProcessosSetorHttp(processosSetorInsert)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    this.router.navigate(['listar-processos']);
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
        this.loading = false;
    }

    voltar(): void {
        this._processoTabsetComponent.voltar();
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/processo/listar-setores-cliente-processo/listar-setores-cliente-processo.component.ts